export default __webpack_public_path__ + "static/mentions-dark-c4a4b99beba14dce58faaaf5bec5d52b.png";